var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"content":_vm.name,"open-delay":1000,"placement":"top-start"}},[_c('el-radio',{attrs:{"label":_vm.value}},[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }